module.exports = __webpack_public_path__ + "img/siren.4b93bf6c.png";